import React from 'react';
import PropTypes from 'prop-types';

export default function Statistics({ wallet }) {
  return (
    <div className="d-md-flex justify-content-between statistics">
      <div>
        <p>
          Your Plan expires on
          <br />
          <b>{wallet.attributes.plan_expires_on}</b>
        </p>

        <p>
          Next credit expires on
          <br />
          <b>{wallet.attributes.next_credit_expires_on}</b>
        </p>
      </div>
      <div>
        <div className="row">
          <div className="col text-center item">
            <div className="small mt-2">Sessions Available</div>
            <h4 className="mt-2">{wallet.attributes.sessions_available}</h4>
          </div>
          <div className="col text-center item">
            <div className="small mt-2">Sessions Scheduled</div>
            <h4 className="mt-2">{wallet.attributes.sessions_scheduled}</h4>
          </div>
          <div className="col text-center item">
            <div className="small mt-2">Sessions Completed</div>
            <h4 className="mt-2">{wallet.attributes.sessions_completed}</h4>
          </div>
        </div>
      </div>
    </div>
  );
}

Statistics.propTypes = {
  wallet: PropTypes.object.isRequired,
};
